import handler from 'api/handler'

const prefix = '/public/socialFeed'

const methods = {
  fetchFeeds: args => handler({ method: 'get', url: `${prefix}/fetch`, args }),
  updateFeeds: args => handler({ method: 'post', url: `${prefix}/update`, args })
}

export default methods
